// src/api/authApi.js
import apiClient from './apiClient';
const auth = apiClient('auth');

const authApi = {
    login: (credentials) => auth.post('/admin/login', credentials).then(r => r.data),
    me: () => auth.get('/me').then(r => r.data),
    logout: () => auth.post('/logout').then(r => r.data),
};

export default authApi;
